var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7108 0H14.7952V1.49533H12.8675V3.03738H11.2771V1.49533H9.87952V0H4.91566V1.49533H3.22892V3.03738H1.59036V4.57944H0V7.66355H1.59036V10.7477H3.18072V12.2897H4.86747V13.8318H6.36145V15.7009H7.95181V16.9159H9.78313V18.4579H11.1807V20H12.7711V18.4579H14.6988V16.9159H16V15.7009H17.5904V13.8318H19.6145V12.2897H20.8193V10.7477H22.4096V7.66355H24V4.57944H22.4096V3.03738H20.8193V1.49533H19.6145V0H19.7108Z",
    fill: "#F50D5A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolid);
export default __webpack_public_path__ + "static/media/solid.8c1db44ed0adb8e8abf5d91750118298.svg";
export { ForwardRef as ReactComponent };